import React, { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContactForm from "../../ContactForm";


export default function TitleForm() {
  const navigate = useNavigate();
  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    findUs: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    // Prepare FormData object
    const formData = new FormData();
    formData.append("name", formDataState.name);
    formData.append("email", formDataState.email);
    formData.append("phone", formDataState.phone);
    formData.append("findUs", formDataState.findUs);
    formData.append("message", formDataState.message);

    try {
      console.log('hello1');

      const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);

      console.log('hello2');

      if (response.data.success) {
        setStatus("Message sent successfully!");
        // Reset form state
        setFormDataState({
          name: "",
          email: "",
          phone: "",
          findUs: "",
          message: "",
        });
        // ✅ Redirect to thank you page
        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
    } catch (error) {
      console.log('bye');

      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    }
  };
  return (
    <div>

      <style>
        {`
        select
        {
        background:#F4F6F9  !important;
        }
        .select-background{
        background:#F4F6F9 !important;}
        
        `}
      </style>




      <section className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 px-xl-8 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <span className="pq-section-sub-title">Medfirst ENT Centre</span>
                <h1 className="pq-section-title">
                  Functional Endoscopic Sinus Surgery (FESS) in Delhi, India
                </h1>
                <p className="pq-section-description">
                  Functional Endoscopic Sinus Surgery (FESS) is a minimally invasive surgical procedure used to restore normal drainage and function of the sinuses. It involves the use of a nasal endoscope to visualise and remove obstructions such as inflamed tissue, polyps, or anatomical abnormalities that block the natural sinus openings.
                  FESS is commonly performed for patients with chronic rhinosinusitis (with or without nasal polyps) unresponsive to medical therapy, recurrent acute sinus infections, nasal polyps, sinus mucoceles, and fungal sinusitis. Diagnosis involves nasal endoscopy and a CT scan of the sinuses to identify obstruction, inflammation, or anatomical variations.
                  FESS is typically performed under general anaesthesia, and it involves the use of a rigid endoscope inserted through the nostrils and the removal of diseased tissue and bone to open the natural sinus drainage pathways or the preservation of healthy structures to maintain mucociliary function. FESS is a safe and effective procedure that improves sinus ventilation, reduces symptoms, and minimises recurrence when combined with appropriate medical therapy.

                </p>
              </div>


            </div>
            <div className="col-xl-5 pe-xl-4">
                <ContactForm />
              {/*<div className="pq-bg-white pq-form-bg-white p-4">
                <div className="pq-applyform-whitebg p-4">
                  <form onSubmit={sendEmail}>
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={formDataState.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formDataState.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone Number"
                          value={formDataState.phone}
                          onChange={handleChange}
                          required onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="message"
                          Placeholder="Concern"
                          value={formDataState.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <select className="select-background"
                          name="findUs"
                          value={formDataState.findUs}
                          onChange={handleChange}
                          required
                        >
                          <option value="" >How did you find us?</option>
                          <option value="youtube">YouTube</option>
                          <option value="instagram-facebook">Instagram/Facebook</option>
                          <option value="google">Google</option>
                          <option value="reference">Reference</option>
                        </select>
                      </div>
                      <div className="col-md-12 pt-2">
                        <button type="submit">Send Message</button>
                      </div>
                    </div>
                  </form>
                  <p>{status}</p>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
